import { render, staticRenderFns } from "./new-audit-point.vue?vue&type=template&id=5f1108c2&scoped=true"
import script from "./new-audit-point.vue?vue&type=script&lang=js"
export * from "./new-audit-point.vue?vue&type=script&lang=js"
import style0 from "./new-audit-point.vue?vue&type=style&index=0&id=5f1108c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1108c2",
  null
  
)

export default component.exports